import React                      from 'react';
import PropTypes                  from 'prop-types';
import Paper                      from '~/components/Paper';
import GoogleMap                  from 'google-map-react';
import flagIcon                   from '~/assets/icons/flag-checkered.png';
import localMarker                from '~/assets/icons/map-marker.png';
import circleGray                 from '~/assets/icons/circle-gray.png';
import { useTranslation }         from 'react-i18next';
import {
  isTrajectory,
  trasnformGeolocationsToPolyline,
  whereToZoomMyMap,
}                                 from '../utils';
import { MapsApikey }             from '~/config/keys';
import Place                      from '@material-ui/icons/PlaceSharp';
import useStyles                  from './styles';
import EventRecord                from '~/records/EventRecord';

function RouteMap ({geolocations, record, loading }){

  const { t } = useTranslation();
  const classes = useStyles();

  const handleMapApi = (map, maps) => {
      const geodesicPolyline = new maps.Polyline({
        path: trasnformGeolocationsToPolyline(geolocations),
        geodesic: true,
        strokeColor: '#000000',
        strokeOpacity: 1.0,
        strokeWeight: 4
      });
      geodesicPolyline.setMap(map);
  };

  const LocalMarker = () => <img className={classes.markerIcon} src={localMarker}/>;
  const GrayIcon = () => <img className={classes.markerIcon} src={circleGray}/>;
  const FlagIcon = () => <img className={classes.markerIcon} src={flagIcon}/>;
  return(
    <Paper
      Icon={Place}
      iconColor='green'
      title={isTrajectory(record.get('event_type'))? t('event.extras.route') : t('event.extras.location')}
      loading={loading || !geolocations}
    >
      {geolocations && <>
      {isTrajectory(record.get('event_type')) && <div className={classes.mapView}>
        <GoogleMap
          bootstrapURLKeys={{key: MapsApikey}}
          onGoogleApiLoaded={({map, maps}) => handleMapApi(map, maps)}
          defaultCenter={{
            lat: geolocations[Math.floor(geolocations.length/2)].coords_latitude,
            lng: geolocations[Math.floor(geolocations.length/2)].coords_longitude,
          }}
          yesIWantToUseGoogleMapApiInternals
          defaultZoom={whereToZoomMyMap(record.get('distance'))}
        >
          <GrayIcon
            lat={geolocations[0].coords_latitude}
            lng={geolocations[0].coords_longitude}
          />
          <FlagIcon
            lat={geolocations[1].coords_latitude}
            lng={geolocations[1].coords_longitude}
          />
        </GoogleMap>
        </div>}
      {!isTrajectory(record.get('event_type')) && <div className={classes.mapView}>
        <GoogleMap
          bootstrapURLKeys={{key: MapsApikey}}
          defaultCenter={{
            lat: geolocations[0].coords_latitude,
            lng: geolocations[0].coords_longitude,
          }}
          yesIWantToUseGoogleMapApiInternals
          defaultZoom={18}
        >
          <LocalMarker
            lat={geolocations[0].coords_latitude}
            lng={geolocations[0].coords_longitude}
          />
        </GoogleMap>
        </div>}
        </>}
    </Paper>
  );
}

RouteMap.propTypes={
  loading: PropTypes.bool,
  record: PropTypes.instanceOf(EventRecord).isRequired,
  geolocations: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

export default React.memo(RouteMap);
